!function(){"use strict";let t=!1;function e(){var e;(e=document.querySelectorAll(".gm-target, .js-no-transition")).length&&e.forEach(function(t){if(!t.hasAttribute("href")||""===t.getAttribute("href")){var e=t.getAttribute("data-href")||t.getAttribute("data-url")||"#";t.getAttribute("data-collection-handle")?e="/collections/"+t.getAttribute("data-collection-handle"):t.getAttribute("data-product-handle")&&(e="/products/"+t.getAttribute("data-product-handle")),t.setAttribute("href",e),(e.startsWith("/")||e.startsWith(window.location.origin))&&t.removeAttribute("target")}}),function(){var t=document.querySelectorAll('a[target="_blank"]'),e=window.location.hostname;t.forEach(function(t){var i=t.getAttribute("href");i&&(i.startsWith("/")||i.includes(e))&&(t.removeAttribute("target"),t.removeAttribute("rel"))})}(),t||(t=!0,window.requestAnimationFrame(function(){document.querySelectorAll(".header__cart-icon[aria-expanded]").forEach(function(t){var e=t.closest("button, a");e&&(e.setAttribute("aria-expanded",t.getAttribute("aria-expanded")),t.removeAttribute("aria-expanded"))}),document.querySelectorAll('[aria-hidden="true"]').forEach(function(t){t.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])').forEach(function(t){t.setAttribute("tabindex","-1")})}),document.querySelectorAll('.collection-list .collection-item[aria-hidden="true"]').forEach(function(t){t.removeAttribute("aria-hidden"),t.setAttribute("tabindex","-1")}),document.querySelectorAll('.collection-list .collection-item:not([aria-hidden="true"])').forEach(function(t){"-1"===t.getAttribute("tabindex")&&t.removeAttribute("tabindex")}),t=!1}))}if("loading"===document.readyState?document.addEventListener("DOMContentLoaded",e):e(),window.MutationObserver){var i=new MutationObserver(function(t){(t.some(t=>"tabindex"!==t.attributeName&&"aria-hidden"!==t.attributeName)||t.some(t=>t.addedNodes.length>0))&&e()});i.observe(document.body,{childList:!0,subtree:!0,attributes:!0,attributeFilter:["aria-hidden","class"]}),setTimeout(function(){i.disconnect()},4e3)}}(),function(){"use strict";function t(){if(void 0!==window.Cart&&window.Cart.prototype){var e=window.Cart.prototype._calculateMiniCartHeight;window.Cart.prototype._calculateMiniCartHeight=function(){window.requestAnimationFrame?window.requestAnimationFrame(()=>{setTimeout(()=>{e&&e.call(this)},30)}):e&&e.call(this)}}else setTimeout(t,400)}function e(){if(void 0!==window.PhotoSwipe&&window.PhotoSwipe.prototype){var t=window.PhotoSwipe.prototype._calculatePanBounds;t&&(window.PhotoSwipe.prototype._calculatePanBounds=function(){window.requestAnimationFrame?window.requestAnimationFrame(()=>t.apply(this,arguments)):t.apply(this,arguments)})}else setTimeout(e,500)}"complete"===document.readyState?setTimeout(()=>{t(),e()},400):window.addEventListener("load",()=>{setTimeout(()=>{t(),e()},400)},{once:!0})}(),document.addEventListener("DOMContentLoaded",function(){document.querySelectorAll('input[id$="-quantity"]').forEach(function(t){var e=parseInt(t.dataset.customMin)||1,i=t.closest("form");i&&i.addEventListener("submit",function(i){if((parseInt(t.value)||0)<e)return i.preventDefault(),i.stopPropagation(),alert("⚠️ Quantité minimale requise : "+e+" unités.\n\nVeuillez ajuster votre quantité."),t.value=e,t.focus(),!1}),t.addEventListener("change",function(){(parseInt(this.value)||0)<e&&(this.value=e)}),t.addEventListener("blur",function(){(parseInt(this.value)||0)<e&&(this.value=e)})})});



/* ========================================================
   🚀 CORRECTION ARIA POUR ACCESSIBILITÉ 96+
   ======================================================== *

(function() {
  'use strict';

  function fixAriaHidden() {
    // ✅ Trouver tous les éléments aria-hidden qui contiennent des éléments focusables
    var hiddenContainers = document.querySelectorAll('[aria-hidden="true"]');
    
    hiddenContainers.forEach(function(container) {
      // ✅ Vérifier si l'élément contient des éléments focusables
      var focusable = container.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
      
      focusable.forEach(function(element) {
        // ✅ Ajouter tabindex="-1" pour les rendre non-focusables
        if (!element.hasAttribute('tabindex') || element.getAttribute('tabindex') !== '-1') {
          element.setAttribute('tabindex', '-1');
        }
      });
    });

    // ✅ Correction des aria-expanded sur les éléments non-interactifs
    var ariaExpandedElements = document.querySelectorAll('[aria-expanded]:not(button):not(a):not([role="button"])');
    ariaExpandedElements.forEach(function(el) {
      el.removeAttribute('aria-expanded');
    });
  }

  // ✅ Exécuter après le chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(fixAriaHidden, 500);
    });
  } else {
    setTimeout(fixAriaHidden, 500);
  }

  // ✅ Observer les changements
  if (window.MutationObserver) {
    var observer = new MutationObserver(function() {
      fixAriaHidden();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'aria-expanded']
    });
    setTimeout(function() { observer.disconnect(); }, 5000);
  }

})();

/* ========================================================
   🚀 CORRECTION DES LIENS SANS TEXTE
   ======================================================== *

(function() {
  'use strict';

  function fixEmptyLinks() {
    // ✅ Trouver tous les liens sans texte
    var links = document.querySelectorAll('a:not([aria-label]):not([aria-labelledby])');
    
    links.forEach(function(link) {
      var text = link.textContent.trim();
      var img = link.querySelector('img');
      
      // ✅ Si le lien contient une image, utiliser son alt
      if (img && img.getAttribute('alt')) {
        link.setAttribute('aria-label', img.getAttribute('alt'));
      }
      // ✅ Si le lien contient un SVG, ajouter un label générique
      else if (link.querySelector('svg')) {
        var parentText = link.closest('li')?.textContent?.trim() || '';
        if (parentText) {
          link.setAttribute('aria-label', parentText);
        } else {
          link.setAttribute('aria-label', 'Lien');
        }
      }
      // ✅ Si le lien est vide mais a un title
      else if (link.getAttribute('title')) {
        link.setAttribute('aria-label', link.getAttribute('title'));
      }
      // ✅ Si le lien est complètement vide
      else if (text === '' && !link.querySelector('img') && !link.querySelector('svg')) {
        link.setAttribute('aria-label', 'Lien');
      }
    });
  }

  // ✅ Exécuter après le chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(fixEmptyLinks, 600);
    });
  } else {
    setTimeout(fixEmptyLinks, 600);
  }

})();*/
// Enforce minimum quantity in cart (mini-cart + cart page)
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-action="decrease-quantity"]');
  if (!btn) return;

  var container = btn.closest('.quantity-selector');
  if (!container) return;

  var input = container.querySelector('.quantity-selector__value');
  if (!input) return;

  var minQty = parseInt(input.getAttribute('min')) || 1;
  var currentQty = parseInt(input.value) || 1;

  if (currentQty <= minQty) {
    e.preventDefault();
    e.stopImmediatePropagation();
    input.value = minQty;
    var msg = container.querySelector('.qty-min-warning');
    if (!msg) {
      msg = document.createElement('span');
      msg.className = 'qty-min-warning';
      msg.style.cssText = 'color:orange;font-size:12px;display:block;';
      msg.textContent = '⚠️ Quantité minimale : ' + minQty + ' unités';
      container.appendChild(msg);
      setTimeout(function() { msg.remove(); }, 3000);
    }
  }
});
